import ACTIONS from "../constants/actions";

const {
  GET_ALL_STATUS,
  GET_ALL_STATUS_FAIL,
  GET_ALL_STATUS_SUCCESS,
  POST_STATUS,
  POST_STATUS_FAIL,
  POST_STATUS_SUCCESS,
  EDIT_STATUS,
  EDIT_STATUS_SUCCESS,
  EDIT_STATUS_FAIL,
  GET_BRANCH_REQUEST,
  GET_BRANCH_SUCCESS,
  GET_BRANCH_FAIL,
  POST_BRANCH,
  POST_BRANCH_SUCCESS,
  POST_BRANCH_FAIL,
  DELETE_BRANCH,
  DELETE_BRANCH_SUCCESS,
  DELETE_BRANCH_FAIL,
  UPDATE_BRANCH,
  UPDATE_BRANCH_SUCCESS,
  UPDATE_BRANCH_FAIL,
  GET_ALL_ORGANIZATION,
  GET_ALL_ORGANIZATION_SUCCESS,
  GET_ALL_ORGANIZATION_FAIL,
  GET_ALL_HOLIDAY,
  GET_ALL_HOLIDAY_SUCCESS,
  GET_ALL_HOLIDAY_FAIL,
  GET_SETTING_OVERTIME,
  GET_SETTING_OVERTIME_SUCCESS,
  GET_SETTING_OVERTIME_FAIL,
  GET_PAYROLL_COMMISSION_SETTING,
  GET_PAYROLL_COMMISSION_SETTING_SUCCESS,
  GET_PAYROLL_COMMISSION_SETTING_FAIL,
  GET_SETTING_QRCODE,
  GET_SETTING_QRCODE_FAIL,
  GET_SETTING_QRCODE_SUCCESS,
  GET_SETTING_QRCODE_ROOM,
  GET_SETTING_QRCODE_ROOM_FAIL,
  GET_SETTING_QRCODE_ROOM_SUCCESS,
} = ACTIONS;

const initialState = {
  isLoadingStatus: false,
  listStatus: [],
  isLoadingBranch: false,
  branches: [],
  isLoadingHoliday: false,
  holidays: [],
  isLoadingCommissionSetting: false,
  commissionSetting: [],
};

const settingPageReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_ALL_STATUS:
      return {
        ...state,
        isLoadingStatus: true,
      };
    case GET_ALL_STATUS_SUCCESS:
      return {
        ...state,
        isLoadingStatus: false,
        listStatus: action.payload,
      };
    case GET_ALL_STATUS_FAIL:
      return {
        ...state,
        isLoadingStatus: false,
      };
    case POST_STATUS:
      return {
        ...state,
      };
    case POST_STATUS_SUCCESS:
      return {
        ...state,
      };
    case POST_STATUS_FAIL:
      return {
        ...state,
      };
    case EDIT_STATUS:
      return {
        ...state,
      };
    case EDIT_STATUS_SUCCESS:
      return {
        ...state,
      };
    case EDIT_STATUS_FAIL:
      return {
        ...state,
      };
    case GET_BRANCH_REQUEST:
      return {
        ...state,
        isLoadingBranch: true,
      };
    case GET_BRANCH_SUCCESS:
      return {
        ...state,
        isLoadingBranch: false,
        branches: action.payload,
      };
    case GET_BRANCH_FAIL:
      return {
        ...state,
        isLoadingBranch: false,
      };
    case POST_BRANCH:
      return {
        ...state,
      };
    case POST_BRANCH_SUCCESS:
      return {
        ...state,
      };
    case POST_BRANCH_FAIL:
      return {
        ...state,
      };
    case DELETE_BRANCH:
      return {
        ...state,
      };
    case DELETE_BRANCH_SUCCESS:
      return {
        ...state,
      };
    case DELETE_BRANCH_FAIL:
      return {
        ...state,
      };
    case UPDATE_BRANCH:
      return {
        ...state,
      };
    case UPDATE_BRANCH_SUCCESS:
      return {
        ...state,
      };
    case UPDATE_BRANCH_FAIL:
      return {
        ...state,
      };
    case GET_ALL_ORGANIZATION:
      return {
        ...state,
        isLoadingGetOrganization: true,
      };
    case GET_ALL_ORGANIZATION_SUCCESS:
      return {
        ...state,
        isLoadingGetOrganization: false,
        allOrganizationData: action.payload,
      };
    case GET_ALL_ORGANIZATION_FAIL:
      return {
        ...state,
        isLoadingGetOrganization: false,
      };
    case GET_ALL_HOLIDAY:
      return {
        ...state,
        isLoadingHoliday: true,
      };
    case GET_ALL_HOLIDAY_SUCCESS:
      return {
        ...state,
        isLoadingHoliday: false,
        holidays: action.payload,
      };
    case GET_ALL_HOLIDAY_FAIL:
      return {
        ...state,
        isLoadingHoliday: false,
      };
    case GET_SETTING_OVERTIME:
      return {
        ...state,
        isLoadingOvertime: true,
      };
    case GET_SETTING_OVERTIME_SUCCESS:
      return {
        ...state,
        isLoadingOvertime: false,
        overtimes: action.payload,
      };
    case GET_SETTING_OVERTIME_FAIL:
      return {
        ...state,
        isLoadingOvertime: false,
      };
    case GET_PAYROLL_COMMISSION_SETTING:
      return {
        ...state,
        isLoadingCommissionSetting: true,
      };
    case GET_PAYROLL_COMMISSION_SETTING_SUCCESS:
      return {
        ...state,
        isLoadingCommissionSetting: false,
        commissionSetting: action.payload,
      };
    case GET_PAYROLL_COMMISSION_SETTING_FAIL:
      return {
        ...state,
        isLoadingCommissionSetting: false,
      };
    case GET_SETTING_QRCODE:
      return {
        ...state,
        isLoadingSettingQRcode: true,
      };
    case GET_SETTING_QRCODE_SUCCESS:
      return {
        ...state,
        isLoadingSettingQRcode: false,
        qrcodes: action.payload,
      };
    case GET_SETTING_QRCODE_FAIL:
      return {
        ...state,
        isLoadingSettingQRcode: false,
      };
    case GET_SETTING_QRCODE_ROOM:
      return {
        ...state,
        isLoadingSettingQRcodeRoom: true,
      };
    case GET_SETTING_QRCODE_ROOM_SUCCESS:
      return {
        ...state,
        isLoadingSettingQRcodeRoom: false,
        qrcodesRoom: action.payload,
      };
    case GET_SETTING_QRCODE_ROOM_FAIL:
      return {
        ...state,
        isLoadingSettingQRcodeRoom: false,
      };
    default:
      return state;
  }
};

export default settingPageReducer;
